module.exports = "<app-control-imagen \r\n  [imageData]=\"sfcontrol.value\"\r\n  (imageDataReturned)=\"imageReturned($event)\"\r\n>\r\n</app-control-imagen>"